var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function PersonManIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 13C14.2091 13 16 11.2091 16 9C16 8.23522 15.7854 7.52056 15.4131 6.91299C14.1943 8.00244 11.4799 8.00244 10.0798 8.00244C9.0956 8.00244 8.42632 8.70938 8.01662 9.36715C8.202 11.4042 9.91464 13 12 13ZM6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9C18 10.5367 17.4223 11.9385 16.4722 13H17.9863C18.5362 13 19.1017 13.4301 19.2507 13.965L20.9411 20.0351C21.0896 20.5681 20.7632 21.0005 20.2053 21.0009L3.7729 21.0145C3.21808 21.0149 2.88732 20.5844 3.03532 20.0485L4.71491 13.9668C4.86238 13.4329 5.43187 13 5.97755 13H7.52779C6.57771 11.9385 6 10.5367 6 9ZM17.4594 15.0001L6.50304 15.0021L5.39234 19L18.5846 19.0008L17.4594 15.0001Z", fill: "" })));
}
export var PersonManIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: PersonManIconInner }, props))); };
//# sourceMappingURL=PersonManIcon.js.map